import { useState, useCallback } from 'react';
import "antd/dist/antd.dark.min.css";
import { Layout, Menu } from "antd";
import { getLocalStorageValue, setLocalStorageValue, removeLocalStorageValue } from "./store/localstorage";
import ViewSettingsSensors from "./ViewSettingsSensors"
import ViewSettingsProfile from "./ViewSettingsProfile"
import PanelLocalServer from "./PanelLocalServer"
import ViewAnalysis from "./ViewAnalysis"
import ViewWorkouts from "./ViewWorkouts"
import ViewPlanner from "./ViewPlanner"
import ViewActivities from './ViewActivities';

import {
  PieChartOutlined,
  CarryOutOutlined,
  CalendarOutlined,
  SettingOutlined,
  CrownTwoTone,
  DatabaseOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import { logoutUser } from './store/store';


const { Content, Sider } = Layout;

function View(props) {
  switch (props.value) {
    case 'sensors':
      return <ViewSettingsSensors/>
    case 'connections':
      return <PanelLocalServer/>
    case 'profile':
      return <ViewSettingsProfile/>
    case 'analysis':
      return <ViewAnalysis/>
    case 'workouts':
      return <ViewWorkouts onStartWorkout={props.onStartWorkout} onNavigate={props.onNavigate}/>
    case 'planner':
      return <ViewPlanner onNavigate={props.onNavigate}/>
    case 'activities':
        return <ViewActivities/>
    default:
      return <p>Unknown view key</p>
  }
}

const DEFAULT_VIEW = 'activities'
const VIEW_KEY = 'trainer/currentView'

function LayoutMain({ onStartWorkout, onNavigate }) {
  const [ currentView, setCurrentView ] = useState(() => getLocalStorageValue(VIEW_KEY, DEFAULT_VIEW))

  const handleMenuClick = useCallback(item => {
    if (item.key === 'logout') return
    setCurrentView(item.key)
    setLocalStorageValue(VIEW_KEY, item.key)
  }, [setCurrentView])

  const handleNavigate = useCallback(viewKey => {
    setCurrentView(viewKey)
    setLocalStorageValue(VIEW_KEY, viewKey)
  }, [setCurrentView])

  const handleLogoutClick = () => {
    removeLocalStorageValue(VIEW_KEY)
    logoutUser()
  }

  const MenuItems = [
    { label: 'Активности', key: 'activities', icon: <DatabaseOutlined/> },
    { label: 'Аналитика', key: 'analysis', icon: <PieChartOutlined/> },
    { label: 'Тренировки', key: 'workouts', icon: <CarryOutOutlined/> },
    { label: 'Планировщик', key: 'planner', icon: <CalendarOutlined/> },
    {
      label: 'Настройки',
      key: 'settings',
      icon: <SettingOutlined/>,
      children: [
        { label: 'Подключения', key: 'connections' },
        { label: 'Датчики', key: 'sensors' },
        { label: 'Профиль', key: 'profile' },
      ],
    },
    { type: 'divider' },
    { label: 'Выйти', key: 'logout', icon: <LogoutOutlined/>, onClick: handleLogoutClick },
  ];
  
  return (
    <Layout style={{ height: "100%" }}>
      <Sider width={200} className="site-layout-background">
        <a href={process.env.REACT_APP_SITE_URL || '/'} className="app-header-link"><div className="app-header"><CrownTwoTone /> Спорт по уму</div></a>
        <Menu
          mode="inline"
          className="app-menu"
          items={MenuItems}
          defaultSelectedKeys={currentView}
          defaultOpenKeys={currentView === 'sensors' || currentView === 'profile' ? ['settings'] : []}
          onClick = { handleMenuClick } />
      </Sider>
      <Layout>
        <Content className="site-layout-background side-view">
          <View value={ currentView } onStartWorkout={onStartWorkout} onNavigate={handleNavigate}/>
        </Content>
      </Layout>
    </Layout>
  )
}

export default LayoutMain;
